const featureResponseStub = {
    type: 'FeatureCollection',
    features: [],
};

export {
    featureResponseStub,
};
